const data = {
  LeftSide: {
    Welcome: [
      {
        id: 1,
        Heading: "Welcome",
      },
    ],
    Content: {
      Content: [
        {
          id: 1,
          para1: "Sign in to continue",
        },
      ],
      ContentPassword: [
        {
          id: 1,
          para1: "Reset Your Password",
        },
      ],
      VerifiContent: {
        Header: [
          {
            id: 1,
            Name: "Verification",
          },
        ],
        Content: [
          {
            id: 1,
            OTP: "Enter OTP",
          },
        ],
        Content2: [
          {
            id: 1,
            OTP: "OTP expires in ;",
          },
        ],
        Content4: [
          {
            id: 1,
            OTP1: "Didn’t Receive a verification Code ?",
          },
        ],
        Content5: [
          {
            id: 1,
            OTP2: "Resend OTP?",
          },
        ],
      },
    },

    Content2: [
      {
        id: 1,
        para2: `Lorem Ipsum is simply dummy text of the printing and typesetting 
                industry. Lorem Ipsum has been the industry's standard dummy text ever`,
      },
    ],
    NewPassword: {
      Header: [
        {
          id: 1,
          Header: "Reset Your Password",
        },
      ],
      Label1: [
        {
          id: 1,
          Label: "New Password..",
          Label2: "Confirm Password..",
        },
      ],
    },
    Details: {
      Detail1: [
        {
          id: 1,
          Deatils: "Enter Your Details",
        },
      ],
      Details2: [
        {
          id: 2,
          Details: "Recover Your Account",
        },
      ],
      Details3: [
        {
          id: 1,
          Details: "Enter Your OTP",
        },
      ],
      Details4: [
        {
          id: 1,
          Details: "Enter Your New Password",
        },
      ],
    },
    LoginPages: [
      {
        id: 1,
        LoginHead: "Login in to UDS",
      },
    ],
    ForgotPage: [
      {
        id: 1,
        Forgot: "Forgot Password",
      },
    ],
    InputLabel: [
      {
        id: 1,
        labelEm: "Email",
        labelPas: "Password",
      },
    ],
    Button: {
      Button1: [
        {
          id: 1,
          ButtonName: "LOGIN",
        },
      ],
      Button2: [
        {
          id: 1,
          ButtonNameSendOTP: "SEND OTP",
        },
      ],
      Button3: [
        {
          id: 1,
          ButtonNameVerify: "VERIFY",
        },
      ],
      Button4: [
        {
          id: 1,
          ButtonUpdate: "UPDATE",
        },
      ],
    },
    ForgotPassword: [
      {
        id: 1,
        Forgot: "Forgot Password ?",
      },
    ],
  },
};
export default data;
